<!--
 * @Author: zl
 * @Date: 2022-09-15 14:23:27
 * @LastEditTime: 2022-09-16 14:02:36
 * @LastEditors: zl
 * @Description: 审计日志
-->
<template>
	<div class='AuditLog-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">审 计 日 志</h2>
				<el-descriptions :column="4"
								 size="small"
								 border
								 class="custom-descriptions sp-descriptions">
					<el-descriptions-item label="日志名称"
										  :span="4">{{ form.sname }}</el-descriptions-item>
					<el-descriptions-item label="工程项目名称"
										  :span="4">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="4">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="施工部位"
										  :span="4">{{ form.site }}</el-descriptions-item>
					<el-descriptions-item label="当前日期"
										  contentClassName="w100">
						{{ form.nowDate ? form.nowDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="天气"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.weather }}</el-descriptions-item>
					<el-descriptions-item label="最高温度"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.maxTem }}</el-descriptions-item>
					<el-descriptions-item label="最低气温"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.minTem }}</el-descriptions-item>
					<el-descriptions-item label="风速"
										  contentClassName="w100">{{ form.speed }}</el-descriptions-item>
					<el-descriptions-item label="风向"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.logNo }}</el-descriptions-item>
					<el-descriptions-item label="编辑人"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.editor }}</el-descriptions-item>
					<el-descriptions-item label="编号"
										  labelClassName="w110"
										  contentClassName="w100">{{ form.logNo }}</el-descriptions-item>
					<el-descriptions-item v-for="(item, index) in form.logParagraphList"
										  :key="item.id"
										  :label="'段落' + (index + 1)"
										  contentClassName="pd0"
										  :span="4">
						<el-descriptions style="margin: -2px"
										 :column="2"
										 size="small"
										 border
										 class="custom-descriptions sp-descriptions">
							<el-descriptions-item label="记录人">{{ item.recorder }}</el-descriptions-item>
							<el-descriptions-item label="施工人数">{{ item.personNum }}</el-descriptions-item>
							<el-descriptions-item label="A类别"
												  :span="2">{{ item.typeAName }}</el-descriptions-item>
							<el-descriptions-item label="B类别"
												  :span="2">{{ item.typeBName }}</el-descriptions-item>
							<el-descriptions-item :span="2"
												  label="段落内容"
												  contentClassName="h200">
								{{ item.content }}
							</el-descriptions-item>
							<el-descriptions-item label="文件上传"
												  :span="2">
								<myUpload listType="list"
										  :ref="'meetingUpload' + index"
										  tableName="audit_work_log"
										  :assortment="'test' + index"
										  width="auto"
										  height="auto"
										  :aid="form.id"
										  uploadType="2"
										  mode="view"
										  class="h100 w100"></myUpload>
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
				</el-descriptions>
				<div class="center-box">施工单位、人、机、料情况</div>
				<el-descriptions style="margin-top: -2px"
								 :column="1"
								 size="small"
								 border
								 class="custom-descriptions sp-descriptions">
					<el-descriptions-item v-for="(i, index) in form.auditLogUnitList"
										  :key="i.id"
										  :label="'单位' + (index + 1)"
										  contentClassName="pd0">
						<el-descriptions style="margin: -2px"
										 :column="2"
										 size="small"
										 border
										 class="custom-descriptions">
							<el-descriptions-item label="单位名称">{{ i.sname }}</el-descriptions-item>
						</el-descriptions>
						<el-descriptions style="margin: -2px"
										 :column="5"
										 direction="vertical"
										 size="small"
										 border
										 class="custom-descriptions sp-descriptions">
							<el-descriptions-item label="施工设备"
												  labelClassName="text-center"
												  contentClassName="w100">{{ i.instrument }}</el-descriptions-item>
							<el-descriptions-item label="数量"
												  labelClassName="text-center"
												  contentClassName="w100">{{ i.insNum }}</el-descriptions-item>
							<el-descriptions-item label="人员类别"
												  labelClassName="text-center"
												  contentClassName="w100">{{ i.personType }}</el-descriptions-item>
							<el-descriptions-item label="人员数量"
												  labelClassName="text-center"
												  contentClassName="w100">{{ i.personNum }}</el-descriptions-item>
							<el-descriptions-item label="主要材料进场情况"
												  labelClassName="text-center"
												  contentClassName="w100">{{ i.conditions }}</el-descriptions-item>
						</el-descriptions>
						<el-descriptions style="margin: -2px"
										 :column="2"
										 size="small"
										 border
										 class="custom-descriptions">
							<el-descriptions-item label="单位内容"
												  contentClassName="h200">
								{{ i.content }}
							</el-descriptions-item>
						</el-descriptions>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {
				auditLogUnitList: [],
				logParagraphList: [],
			},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectWorkLogDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
.center-box {
	height: 50px;
	line-height: 50px;
	text-align: center;
	border: 2px solid #ebeef5;
	color: #000;
	margin-top: -2px;
}
</style>